import i18n from "../../../../constants/i18n";
import { USER_SELFIE_VERIFICATION_PHOTOS_HEADERS } from "../../../../constants/table-custom-headers/User";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";
import getSelfieVerificationPhotosStore from "../../../../stores/user-store/selfie-verification-photos-store";

const UserSelfieVerificationPhotosData = withLiteObserverAndTheme(() => {
  const userSelfieVerificationPhotos =
    getSelfieVerificationPhotosStore().userSelfieVerificationPhotos.get();
  return (
    <Et3Table
      columns={USER_SELFIE_VERIFICATION_PHOTOS_HEADERS}
      rows={userSelfieVerificationPhotos}
      title={i18n.get("SELFIE_VERIFICATION_PHOTOS")}
      shouldBeFlagged={false}
      titleKey={"SELFIE_VERIFICATION_PHOTOS"}
    />
  );
});

export default UserSelfieVerificationPhotosData;
